/**
 * Previous: js/chudej-scripts.js
 */
function showSearchForm() {
    jQuery('#search-screen').addClass('active');
}

function hideSearchForm() {
    jQuery('#search-screen').removeClass('active');
}

function openTab(evt, tabName) {
    jQuery('.tabcontent').removeClass('active');
    jQuery('.tablinks').removeClass('active');

    jQuery('div#' + tabName).addClass('active');
    evt.currentTarget.className += " active";
}

// jQuery('button.tablinks').click(function(){
//     jQuery('.tabcontent').removeClass('active');
//     jQuery('.tablinks').removeClass('active');
//
//     var tabName = jQuery(this).attr('data-tab');
//     jQuery('div#'+tabName).addClass('active');
//     jQuery(this).addClass('active');
// });


jQuery(document).ready(function () {
    jQuery('.tablinks').click(function () {
        jQuery('.tabcontent').removeClass('active');
        jQuery('.tablinks').removeClass('active');

        var tabName = jQuery(this).attr('data-tab');
        jQuery('div#' + tabName).addClass('active');
        jQuery(this).addClass('active');
    });

    // jQuery('.product__specifications table').addClass('table table-responsive');
    var newText = 'Nahrát soubor'; // set your message here
    jQuery('.frm_compact_text').html(newText);
    var removeFileText = 'Odstranit soubor'; // set your message here
    jQuery('.dz-remove').html(removeFileText);

    jQuery('.contact__item a[href=#]').click(function (e) {
        e.preventDefault();
    })

    jQuery(document).on("click", ".contact-heading", function (e) {
        jQuery(this).toggleClass("active");
        jQuery(this).parent().next().find(".contact__item").slideToggle();
    });

    jQuery(document).on("click", ".about-company-menu", function (e) {
        e.preventDefault();

    });

    jQuery(document).on("click", ".video-wrapper .scroll-btn", function (e) {
        e.preventDefault();

        var header_height = $(".site-header").outerHeight() || 0;
        var adminbar_height = $("#wpadminbar").outerHeight() || 0;
        var offset = header_height + adminbar_height;

        $('html,body').animate({
            scrollTop: $("#content").offset().top
        }, 'slow');
    });

    jQuery(document).on("click", ".scroll-btn-page", function (e) {
        //e.preventDefault();

        var header_height = $(".site-header").outerHeight() || 0;
        var adminbar_height = $("#wpadminbar").outerHeight() || 0;
        var offset = header_height + adminbar_height;

        $('html,body').animate({
            scrollTop: $(".goods-categories-box").offset().top - 50
        }, 'slow');
    });

});

jQuery(document).ready(function ($) {
    (function () {
        var body_el = $(document.body);

        if (
            !body_el.hasClass("page-template-template-contact")
            && !body_el.hasClass("page-template-template-contact-new")
        ) {
            return;
        }

        $(".contact-btns .contact-btn").on("click", function (e) {
            var this_btn = $(this);
            if (!this_btn.hasClass("active")) {
                this_btn.siblings().removeClass("active");
                this_btn.addClass("active");

                var btn_index = this_btn.index() + 1;

                var contact_row = this_btn.closest(".row");

                contact_row.find(".contact-section.active").removeClass("active").fadeOut(300, function () {
                    contact_row.find(".contact-section:nth-child(" + btn_index + ")").addClass("active").fadeIn(300);
                });
            }
        });

        initMap();

        function initMap() {

            var map_wraps = $(".google-map-wrap");

            if (map_wraps.length <= 0) {
                return;
            }

            map_wraps.each(function () {
                var gmap = $(this).find(".google-map");

                var gmap_options = gmap.data("gmap-options");

                var center_lat = gmap_options.center.lat;
                var center_lng = gmap_options.center.lng;

                var map_zoom = gmap_options.zoom || 14;

                var args = {
                    zoom: map_zoom,
                    center: new google.maps.LatLng(center_lat, center_lng),
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                    //disableDefaultUI: true
                };

                var map = new google.maps.Map(gmap[0], args);

                map.markers = [];

                //marker variables
                var marker_lat = center_lat;
                var marker_lng = center_lng;
                var marker_title = "";
                //var marker_content = "";

                var latlng = new google.maps.LatLng(marker_lat, marker_lng);

                // create marker
                var marker = new google.maps.Marker({
                    position: latlng,
                    //icon        : marker_icon,
                    title: marker_title,
                    map: map
                });

                // add to array
                map.markers.push(marker);

            });
        }
    })();
});

jQuery(document).ready(function ($) {
    (function () {
        var body_el = $(document.body);

        if (!body_el.hasClass("archive")) {
            return;
        }

        function referenceCategories() {
            // Menu item active - underline effect
            const menuItems = $(".reference-categories");
            menuItems.each(function () {
                $(this).on("click", function () {
                    $(this).toggleClass('-active');
                });
            });
        }

        referenceCategories();
    })();

    // Reference categories menu -active state
    (function () {
        var body_el = $(document.body);

        if (!body_el.hasClass("single")) {
            return;
        }

        function referenceCategories() {
            // Menu item active - underline effect
            const menuItems = $(".reference-categories");
            menuItems.each(function () {
                $(this).on("click", function () {
                    $(this).toggleClass('-active');
                });
            });
        }

        referenceCategories();
    })();

    // Embla Slider - detail reference
    (function () {
        const body_el = $(document.body);

        if (
            !body_el.hasClass("single-chudej_reference")
        ) {
            return;
        }
        const wrap = document.querySelector(".embla");

        if (wrap) {
            const viewPort = wrap.querySelector(".embla__viewport");
            const prevBtn = wrap.querySelector(".embla__button--prev");
            const nextBtn = wrap.querySelector(".embla__button--next");
            const embla_reference = EmblaCarousel(viewPort, {loop: true, align: "start"});

            prevBtn.addEventListener('click', embla_reference.scrollPrev, false);
            nextBtn.addEventListener('click', embla_reference.scrollNext, false);
        }
    })();

    // Embla Carousel - Sortiment kategorie vpusti neptun
    (function () {
        const body_el = $(document.body);

        if (
            !body_el.hasClass("term-podlahove-vpusti-s-plovakem-neptun")
        ) {
            return;
        }

        const wrap_neptun = document.querySelector(".neptun-slider");

        if (wrap_neptun) {
            const viewPort_neptun = wrap_neptun.querySelector(".embla__viewport");
            const prevBtn_neptun = wrap_neptun.querySelector(".embla__button--prev");
            const nextBtn_neptun = wrap_neptun.querySelector(".embla__button--next");
            const embla_neptun = EmblaCarousel(viewPort_neptun, {loop: true, align: "start"});

            prevBtn_neptun.addEventListener('click', embla_neptun.scrollPrev, false);
            nextBtn_neptun.addEventListener('click', embla_neptun.scrollNext, false);
        }
    })();

    // Embla Carousel - Detail produktu
    (function () {
        const body_el = $(document.body);

        if (
            !body_el.hasClass("single-product")
        ) {
            return;
        }

        const wrap = document.querySelector(".embla");

        if (wrap) {
            const viewPort = wrap.querySelector(".embla__viewport");
            const prevBtn = wrap.querySelector(".embla__button--prev");
            const nextBtn = wrap.querySelector(".embla__button--next");
            const embla = EmblaCarousel(viewPort, {loop: false, align: "start"});

            prevBtn.addEventListener('click', embla.scrollPrev, false);
            nextBtn.addEventListener('click', embla.scrollNext, false);
        }

    })();

    // Embla Slider - detail reference
    (function () {
        const body_el = $(document.body);

        if (
            !body_el.hasClass("page-template-template-vernostni-program")
        ) {
            return;
        }
        const wrap = document.querySelector(".embla-loyalty");

        if (wrap) {
            const viewPort = wrap.querySelector(".embla__viewport");
            EmblaCarousel(viewPort, {loop: true, align: "start"});
        }
    })();
});

/**
 * Previous: custom-scripts.js
 */
// Helper variable to check if the last click was
// on "load more products" button or on pagination item.
var chudej_lmp_pagination_clicked = false;


/**
 * Function called when "Load more products" AJAX finishes.
 */
var chudej_lmp_after_load = function () {
    if (!chudej_lmp_pagination_clicked) {
        return;
    }

    var admin_bar = jQuery("#wpadminbar");
    var offset = (jQuery("div.products-box").offset().top - 32);

    if (admin_bar.length > 0 && screen.width >= 600) {
        offset -= admin_bar.outerHeight();
    }

    jQuery("html, body").animate({scrollTop: offset}, 500);
};


jQuery(document).ready(function ($) {
    // Add "im-loaded" class to body when the document is ready.
    setTimeout(function () {
        $(document.body).addClass("im-loaded");
    }, 1000);

    // On "Load more products" button click...
    $(document).on("click", ".lmp_button", function () {
        chudej_lmp_pagination_clicked = false;
    });

    // On products pagination click....
    $(document).on("click", ".woocommerce-pagination > ul > li > a", function () {
        chudej_lmp_pagination_clicked = true;
    });

    // Product archive / category / tag - Order form autosubmit.
    $(document).on("change", "#woocommerce-ordering-select #orderby-select", function () {
        $("#woocommerce-ordering-select")[0].submit();
    });

    $(document).on("change", "#woocommerce-ordering-radio input[type='radio']", function () {
        $("#woocommerce-ordering-radio")[0].submit();
    });

    // Horizontal filters.
    $(document).on("click", ".filters-horizontal .bapf_sfilter .bapf_head", function () {
        $(this).closest(".bapf_sfilter").toggleClass("active");
    });

    $(document).on('frmFormComplete', function (event, form, response) {
        window.location.hash = "odeslano";
    });

    var lightbox_video_link = $('.home-video .btn-play');
    if (lightbox_video_link.length > 0) {
        lightbox_video_link.simpleLightbox();
    }

    move_site_header();
    synchronize_taxonomy_iframes_offset();
    move_responsive_button();
    synchronize_home_sortiment_news_height();
    $(window).resize(function () {
        move_site_header();
        synchronize_taxonomy_iframes_offset();
        move_responsive_button();
        synchronize_home_sortiment_news_height();
    });

    (function () {
        var images = $("body.single-product div.product .product__specifications img");

        images.each(function () {
            var image = $(this);
            var image_cloned = image.clone();
            var anchor = $("<a></a>")
                .attr("href", image.attr("src"))
                .append(image_cloned);

            image.replaceWith(anchor);
            anchor.simpleLightbox();
        });
    })();

    function move_responsive_button() {
        var current_lang = $("html").attr("lang");
        if (current_lang === "cs-CZ") {
            if (window.matchMedia("(max-width: 1200px)").matches) {

                var page_notice = $(".page-notice");
                if (page_notice.length > 0) {

                    page_notice_height = parseInt(page_notice.outerHeight());

                    var offset = 0;
                    if ($("body").hasClass("header-redesign")) {
                        offset = 68;
                    } else {
                        //offset = 53;
                        offset = 31;
                    }

                    btn_top = page_notice_height + offset;

                    $("#responsive-menu-button").attr('style', 'top: ' + btn_top + 'px !important');
                }
            }
        }
    }

    function move_site_header() {
        if (!$("body").hasClass("home")) {
            return;
        }

        if ($(".page-notice").length > 0) {
            var height = $(".page-notice").outerHeight();
            $(".site-header").css("top", "");
            $(".site-header").css("top", height);
        }
    }

    if (typeof lightbox !== 'undefined') {
        lightbox.option({
            'resizeDuration': 500,
            'albumLabel': 'Obrázek %1 / %2'
        });
    }

    function synchronize_taxonomy_iframes_offset() {
        if (!document.body.classList.contains("tax-product_cat")) {
            return false;
        }

        var iframe_wrapper = $(".iframe-wrapper");
        var configurator_link = $(".configurator-link-shortcode");

        if (iframe_wrapper.length <= 0 || configurator_link.length <= 0) {
            return false;
        }

        iframe_wrapper.css("margin-top", "");
        configurator_link.css("margin-top", "");

        if (iframe_wrapper.length === 0) {
            return;
        }

        var iframe_wrapper_offset = iframe_wrapper.get(0).offsetTop;
        var configurator_link_offset = configurator_link.get(0).offsetTop;

        var min_margin_top = 55;

        if (iframe_wrapper_offset > configurator_link_offset) {

            var margin_top = (iframe_wrapper_offset - configurator_link_offset) + (parseInt(iframe_wrapper.css("margin-top")) + (parseInt(iframe_wrapper.find("iframe").css("margin-top"))) * 2);
            var target = configurator_link;
        } else if (configurator_link_offset > iframe_wrapper_offset) {
            var margin_top = configurator_link_offset - iframe_wrapper_offset;
            var target = iframe_wrapper;
        }

        if (window.matchMedia("(min-width: 1200px)").matches && margin_top > min_margin_top) {
            target.css("cssText", "margin-top: " + margin_top + "px !important;");
        }

    }

    function synchronize_home_sortiment_news_height() {

        var sortiment_news_slides = $(".home-sortiment-news .slick-slide, .home-sortiment-news .news-slider-slide");
        if (sortiment_news_slides.length < 4) {
            return;
        }

        sortiment_news_slides.each(function () {
            $(this).css("height", "");
        });

        var biggest_height = Math.max.apply(null, $(sortiment_news_slides).map(function () {
            return $(this).outerHeight();
        }).get());

        sortiment_news_slides.each(function () {
            $(this).css("height", biggest_height);
        });

    }

    (function () {
        if (!document.body.classList.contains("page-template-template-contact-new")) {
            return;
        }

        var groups = $(".contact-new-group[id]");
        var switch_group = function (name) {
            groups.fadeOut(250);

            setTimeout(function () {
                $("#" + name).fadeIn(250);
            }, 250);
        };

        $("#groups-switcher li[data-target]").on("click", function () {
            switch_group($(this).data("target"));
        });
    })();

    // Temporary fix.
    var menu_item = $("#responsive-menu-item-68220");
    if (menu_item.length > 0) {
        var menu_item_link = menu_item.find("a");
        var menu_item_link_href = menu_item_link.attr("href");
        if (menu_item_link_href == "https://www.chudej.cz/contactos/") {
            menu_item_link.attr("href", "/contactos");
        }
    }
});


// WooCommerce Checkout.
jQuery(document).ready(function ($) {
    if (!document.body.classList.contains("woocommerce-checkout")) {
        return;
    }

    function refresh_fields_visibility() {
        const $billing_is_comp = $("#billing_iscomp");
        const $billing_company_wrap = $("#billing_company_field");
        const $billing_ic_wrap = $("#billing_ic_field");
        const $billing_dic_wrap = $("#billing_dic_field");
        const $billing_dic = $("#billing_dic");
        const $billing_dic_dph_wrap = $("#billing_dic_dph_field");
        const $billing_dic_dph = $("#billing_dic_dph");

        const $country = $("#billing_country");
        const country = $country.val();

        if ($billing_is_comp.is(":checked")) {
            if (!$billing_company_wrap.is(":visible")) {
                $billing_company_wrap.slideDown();
            }

            if (!$billing_ic_wrap.is(":visible")) {
                $billing_ic_wrap.slideDown();
            }

            if (!$billing_dic_wrap.is(":visible") && country !== "SK") {
                $billing_dic_wrap.slideDown();
            } else if ($billing_dic_wrap.is(":visible") && country === "SK") {
                $billing_dic_wrap.slideUp();
                $billing_dic.val("");
            }

            if (!$billing_dic_dph_wrap.is(":visible") && country === "SK") {
                $billing_dic_dph_wrap.slideDown();
            } else if ($billing_dic_dph_wrap.is(":visible") && country !== "SK") {
                $billing_dic_dph_wrap.slideUp();
                $billing_dic_dph.val("");
            }
        } else {
            if ($billing_company_wrap.is(":visible")) {
                $billing_company_wrap.slideUp();
            }

            if ($billing_ic_wrap.is(":visible")) {
                $billing_ic_wrap.slideUp();
            }

            if ($billing_dic_wrap.is(":visible")) {
                $billing_dic_wrap.slideUp();
            }

            if ($billing_dic_dph_wrap.is(":visible")) {
                $billing_dic_dph_wrap.slideUp();
            }
        }
    }

    refresh_fields_visibility();
    $(document).on("change", "#billing_iscomp", refresh_fields_visibility);
    $(document).on("change", "#billing_country", refresh_fields_visibility);
});


/**
 * Previous: js/navigation.js
 */
(function () {
    var container, button, menu, links, i, len;

    container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    button = container.getElementsByTagName('button')[0];
    if ('undefined' === typeof button) {
        return;
    }

    menu = container.getElementsByTagName('ul')[0];

    // Hide menu toggle button if menu is empty and return early.
    if ('undefined' === typeof menu) {
        button.style.display = 'none';
        return;
    }

    menu.setAttribute('aria-expanded', 'false');
    if (-1 === menu.className.indexOf('nav-menu')) {
        menu.className += ' nav-menu';
    }

    button.onclick = function () {
        if (-1 !== container.className.indexOf('toggled')) {
            container.className = container.className.replace(' toggled', '');
            button.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-expanded', 'false');
        } else {
            container.className += ' toggled';
            button.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-expanded', 'true');
        }
    };

    // Get all the link elements within the menu.
    links = menu.getElementsByTagName('a');

    // Each time a menu link is focused or blurred, toggle focus.
    for (i = 0, len = links.length; i < len; i++) {
        links[i].addEventListener('focus', toggleFocus, true);
        links[i].addEventListener('blur', toggleFocus, true);
    }

    /**
     * Sets or removes .focus class on an element.
     */
    function toggleFocus() {
        var self = this;

        // Move up through the ancestors of the current link until we hit .nav-menu.
        while (-1 === self.className.indexOf('nav-menu')) {

            // On li elements toggle the class .focus.
            if ('li' === self.tagName.toLowerCase()) {
                if (-1 !== self.className.indexOf('focus')) {
                    self.className = self.className.replace(' focus', '');
                } else {
                    self.className += ' focus';
                }
            }

            self = self.parentElement;
        }
    }

    /**
     * Toggles `focus` class to allow submenu access on tablets.
     */
    (function (container) {
        var touchStartFn, i,
            parentLink = container.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

        if ('ontouchstart' in window) {
            touchStartFn = function (e) {
                var menuItem = this.parentNode, i;

                if (!menuItem.classList.contains('focus')) {
                    e.preventDefault();
                    for (i = 0; i < menuItem.parentNode.children.length; ++i) {
                        if (menuItem === menuItem.parentNode.children[i]) {
                            continue;
                        }
                        menuItem.parentNode.children[i].classList.remove('focus');
                    }
                    menuItem.classList.add('focus');
                } else {
                    menuItem.classList.remove('focus');
                }
            };

            for (i = 0; i < parentLink.length; ++i) {
                parentLink[i].addEventListener('touchstart', touchStartFn, false);
            }
        }
    }(container));
})();


// Mobile menu.
(function () {
    const $hamburger = document.querySelector( "#site-hamburger" );
    const $navWrap   = document.querySelector( "#site-navigation-wrap" );
    const $navClose  = document.querySelector( "#site-navigation-close" );

    // Toggle on hamburger click.
    $hamburger.addEventListener( "click", function() {
        if ( $navWrap.classList.contains( "-active" ) ) {
            $navWrap.classList.remove( "-active" );
            $hamburger.classList.remove( "-active" );
        } else {
            $navWrap.classList.add( "-active" );
            $hamburger.classList.add( "-active" );
        }
    });

    // Close on button click.
    $navClose.addEventListener( "click", function() {
        $navWrap.classList.remove( "-active" );
        $hamburger.classList.remove( "-active" );
    });

    // Show submenu on parent item click.
    function on_navigation_item_click( event, $item ) {
        event.preventDefault();
        event.stopPropagation();

        const $submenu = $item.querySelector( ":scope > ul.submenu" );

        if ( $submenu.classList.contains( "-active" ) ) {
            $submenu.style.height = "0";
            $submenu.classList.remove( "-active" );
        } else {
            $submenu.style.height = $submenu.scrollHeight + "px";
            $submenu.classList.add( "-active" );
        }
    }

    const $navigation = document.querySelector( "#site-navigation" );
    const $navItems   = $navigation.querySelectorAll( ":scope > ul > li.has-submenu" );

    for ( const $item of $navItems ) {
        $item.addEventListener( "click", function ( event ) {
            if ( screen.width >= 1440 ) {
                return;
            }

            on_navigation_item_click( event, $item );
        } );
    }

    // Stop click event propagation from submenu items.
    const $navSubitems = $navigation.querySelectorAll( ":scope > ul > li.has-submenu ul.submenu li" );

    for ( const $item of $navSubitems ) {
        $item.addEventListener( "click", function ( event ) {
            if ( screen.width >= 1440 ) {
                return;
            }

            event.stopPropagation();
        } );
    }
})();


// Client area button.
(function () {
    const $caWrappers = document.querySelectorAll( ".header-ca-wrapper" );

    for ( const $wrapper of $caWrappers ) {
        const $button = $wrapper.querySelector( ".header-ca-button" );
        const $popup  = $wrapper.querySelector( ".header-ca-popup" );

        if ( ! $button || ! $popup ) {
            continue;
        }

        // Phones & tablets - show popup on click.
        $button.addEventListener( "click", function ( event ) {
            if ( window.screen.availWidth >= 576 && window.screen.availWidth < 1200 ) {
                event.preventDefault();
                $popup.classList.toggle( "-active" );
            }
        } );

        $wrapper.addEventListener( "click", function ( event ) {
            event.stopPropagation();
        } );

        document.body.addEventListener( "click", function () {
            if ( window.screen.availWidth < 1200 ) {
                $popup.classList.remove( "-active" );
            }
        } );

        // Desktop - show on hover.
        $button.addEventListener( "mouseenter", function () {
            if ( window.screen.availWidth >= 1200 ) {
                $popup.classList.add( "-active" );
            }
        });

        $wrapper.addEventListener("mouseleave", function () {
            if ( window.screen.availWidth >= 1200 ) {
                $popup.classList.remove( "-active" );
            }
        });
    }
})();
